import Icon from 'veui/components/Icon'

Icon.register({
  'scan-back': {
    paths: [
      {
        d: 'M640 288a32 32 0 010 64H128a32 32 0 010-64zM480 128h160v64a32 32 0 0064 0V96a32 32 0 00-32-32H480a32 32 0 000 64zM96 224a32 32 0 0032-32v-64h160a32 32 0 000-64H96a32 32 0 00-32 32v96a32 32 0 0032 32zm192 416H128V448a32 32 0 00-64 0v224a32 32 0 0032 32h192a32 32 0 000-64zm320-160h-64v-32a16 16 0 00-24.88-13.31l-96 64a16 16 0 000 26.62l96 64A16 16 0 00544 576v-32h64a64 64 0 010 128H448a32 32 0 000 64h160a128 128 0 000-256z'
      }
    ],
    width: '768',
    height: '768'
  }
})
